"use strict";

export default class Work {
    constructor() {
        if ($(".page-node-type-work .horizontal-tabs-list").length > 0) {
            // $(".horizontal-tabs-list").wrap("<div class='injected tabs-top-wrapper'></div>")
            $(".horizontal-tabs-list")

            var $html = $("<div/>", {
                class: 'injected tabs-top-wrapper'
            });
            $html.append($(".horizontal-tabs-list").clone());

            $(".field--name-field-client").after($html);
        }

        $(".tabs-top-wrapper a").click(function ($event) {
            var $id = $(this).attr("href");
            $(".tabs-top-wrapper li.selected").removeClass("selected");
            $("details").hide();
            $($id).show();
            $(this)
                .closest("li")
                .addClass("selected");
        });

        if (
            $(".block-views-blockcontent-blocks-our-work-featured .view-content")
                .length > 0
        ) {


            Drupal.behaviors.myWorkBehavior = {
                attach: function (context, settings) {
                    once('myWorkBehavior', 'html').forEach(function (element) {
                        // Create custom arrow buttons and add them to the DOM
                        var arrowWrapper = $("<div/>", { class: 'slick-arrows'});
                        var $prevArrow = $('<button class="slick-prev slick-arrow custom-prev-arrow" aria-label="Previous">Prev</button>');
                        var $nextArrow = $('<button class="slick-next slick-arrow custom-next-arrow" aria-label="Next">Nexts</button>');
                        arrowWrapper.append($prevArrow, $nextArrow);
                        
                        // Append the arrow buttons to a container element
                        $(".block-views-blockcontent-blocks-our-work-featured").append(arrowWrapper);

                        // Initialize the Slick slider with the custom arrow buttons
                        var $slider = $(
                            ".block-views-blockcontent-blocks-our-work-featured .view-content"
                        ).slick({
                            infinite: true,
                            variableWidth: true,
                            centerMode: true,
                            dots: false,
                            autoplay: true,
                            autoplaySpeed: 5000,
                            speed: 500,
                            arrows: false, // Disable default arrows
                            cssEase: "linear",
                            slidesToScroll: 1,
                            pauseOnHover: true,
                            prevArrow: ".custom-prev-arrow", // Use custom arrow classes as selectors
                            nextArrow: ".custom-next-arrow", // Use custom arrow classes as selectors
                        });

                        $prevArrow.on("click", function () {
                            $slider.slick("slickPrev");
                        });
                        
                        $nextArrow.on("click", function () {
                            $slider.slick("slickNext");
                        });
                    })
                }
            }
        }

        if ($(".view-display-id-our_work .view-filters").length > 0) {
            $(".view-display-id-our_work").before(
                "<div class='js_injected work_filter_tabs'></div>"
            );
            $(".work_filter_tabs").append("<ul class='tab_container'></ul>");
            $(".work_filter_tabs .tab_container").append(
                "<li class='filter_tab'><a href='#' class='show-all'>All</a></li>"
            );
            $(".work_filter_tabs .tab_container").append(
                "<li class='filter_tab'><a href='#' class='show-sector'>Sector</a></li>"
            );
            $(".work_filter_tabs .tab_container").append(
                "<li class='filter_tab'><a href='#' class='show-service'>Services</a></li>"
            );

            showAllWork();
        }

        function showAllWork() {
            clearWorkActive();
            $(".show-all").addClass("active");
            $(".view-display-id-our_work fieldset:nth-child(1)").hide();
            $(".view-display-id-our_work fieldset:nth-child(2)").hide();
            submitFilterForm();
        }

        function showSectorWork() {
            clearWorkActive();
            $(".show-sector").addClass("active");
            $(".view-display-id-our_work fieldset:nth-child(1)")
                .show()
                .addClass("active");
            $(".view-display-id-our_work fieldset:nth-child(2)").hide();
            submitFilterForm();
        }

        function showServicesWork() {
            clearWorkActive();
            $(".show-service").addClass("active");
            $(".view-display-id-our_work fieldset:nth-child(1)").hide();
            $(".view-display-id-our_work fieldset:nth-child(2)")
                .show()
                .addClass("active");
            submitFilterForm();
        }

        function clearWorkActive() {
            $(".view-display-id-our_work fieldset .form-radios").each(function () {
                $(this)
                    .find(".js-form-item:first input")
                    .prop("checked", true);
            });
            $(".work_filter_tabs a").removeClass("active");
        }

        function submitFilterForm() {
            $(".view-display-id-our_work input[type=submit]").click();
        }

        $(".work_filter_tabs .show-all").click(function ($event) {
            $event.preventDefault();
            showAllWork();
        });
        $(".work_filter_tabs .show-sector").click(function ($event) {
            $event.preventDefault();
            showSectorWork();
        });
        $(".work_filter_tabs .show-service").click(function ($event) {
            $event.preventDefault();
            showServicesWork();
        });

        $(document).on("ajaxComplete", function (event, request, settings) {
            if ($(".show-all").hasClass("active")) {
                $(".view-display-id-our_work fieldset:nth-child(1)").hide();
                $(".view-display-id-our_work fieldset:nth-child(2)").hide();
            }
            if ($(".show-sector").hasClass("active")) {
                $(".view-display-id-our_work fieldset:nth-child(1)")
                    .show()
                    .addClass("active");
                $(".view-display-id-our_work fieldset:nth-child(2)").hide();
            }
            if ($(".show-service").hasClass("active")) {
                $(".view-display-id-our_work fieldset:nth-child(1)").hide();
                $(".view-display-id-our_work fieldset:nth-child(2)")
                    .show()
                    .addClass("active");
            }
        });
    }
}
